/**
 * @group UI
 * @summary UI action type constants
 * 
 * @remarks
 * This constant contains action types used in UI components
 * for consistent action handling and state management.
 * 
 * @example
 * ```typescript
 * import { UI_ACTIONS } from '@shared/constants';
 * 
 * dispatch({ type: UI_ACTIONS.TOAST.ADD_TOAST, toast: { id: "1", title: "Success" } });
 * ```
 */
export const UI_ACTIONS = {
  TOAST: {
    ADD_TOAST: 'ADD_TOAST',
    UPDATE_TOAST: 'UPDATE_TOAST',
    DISMISS_TOAST: 'DISMISS_TOAST',
    REMOVE_TOAST: 'REMOVE_TOAST'
  },
  AUTH: {
    SIGNIN: 'signin',
    SIGNUP: 'signup'
  },
  HTTP: {
    GET: 'GET',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE',
    PATCH: 'PATCH'
  }
} as const;
